export default "__VITE_ASSET__21518ac8__"